import { useParams } from "react-router";
import { PageCanvas } from "../../../layouts/PageCanvas";
import { PageContainer } from "../../../layouts/PageContainer";
import { PageHeader } from "../../../layouts/PageHeader";
import { IndividualContainer } from "./IndividualContainer";

const PageIndividual = () => {
  const { registryId, individualId } = useParams();

  return (
    <PageContainer>
      <PageHeader
        // isLoading={isLoadingRegistry}
        back={{ title: "Registry", to: `/app/registries/${registryId}` }}
        title={`Individual: ${individualId}`}
        isIncludeProfile={true}
      ></PageHeader>
      <PageCanvas px={"4"} py={8} overflowY="auto">
        {registryId && individualId && (
          <IndividualContainer
            registryId={registryId}
            individualId={individualId}
          ></IndividualContainer>
        )}
      </PageCanvas>
    </PageContainer>
  );
};

export default PageIndividual;
